import {FC} from "react"
import {Block} from "./Block"
import {CoursePageProps} from "./CoursePageProps"

export const BurnoutRecovery: FC<Pick<CoursePageProps, "course">> = () => {
  return (
    <Block>
      <h1 className="mt-16">Welcome to the Burnout Recovery Program.</h1>
      <p>The main goal of this program is to reduce the various pressures
        that cause stress and burnout and restore motivation and value
        in work, instead of disappointment and devaluation.
      </p>

      <p>During this course, we will begin with a theoretical component that
        explores the development and impact of burnout, including how it
        differs from depression and low mood. From there, we will work
        on specific therapeutic strategies to combat fatigue, detachment, and demotivation.
      </p>

      <p>We will also focus on developing specific habits to aid in
        recovery from burnout, including:
      </p>
      <ul className="list-rhombus">
        <li>Learning to disconnect from work-related problems during rest periods</li>
        <li>Developing self-care practices to restore work-life balance</li>
        <li>Restoring motivation and the value of work</li>
        <li>Engaging in meditations and life hacks that reduce the impact of
          unpleasant work situations that can lead to burnout
        </li>
      </ul>

      <p>We will also work on identifying and addressing the root causes and internal
        voices that contribute to burnout. This will help individuals identify
        and overcome the underlying issues that may trigger or exacerbate symptoms.
      </p>

      <p>We believe that this program can help you in your journey towards healing
        and recovery from burnout. We are here to support and guide you every step of the way.
      </p>
    </Block>
  )
}
